import React from 'react';
import { chunk } from 'lodash';
import { isMobileV2 } from 'src/utils/ui';
import RadioV2QA from './RadioV2QA';
import { DEFAULT_QUESTIONS_PER_COLUMN, RADIO_BUTTON_SIZE } from './constants';

export const getAnswerComponents = ({
  answers = [],
  setElementClicked = () => {},
  setSelectedAnswer = () => {},
  launchAdditionalInfoDisplay = () => {},
}) => {
  const buttonSize = isMobileV2() ? RADIO_BUTTON_SIZE.MEDIUM : RADIO_BUTTON_SIZE.LARGE;
  return answers.map((a, i) => (
    <RadioV2QA
      key={`answer${i}${a.id}${a.value}`}
      adjValue={a.value}
      hint={a.hint}
      label={a.label}
      showInput={a.showInput}
      setElementClicked={setElementClicked}
      setSelectedAnswer={setSelectedAnswer}
      size={buttonSize}
      value={a.id}
      additionalAnswerInfo={a.additionalInfo || {}}
      launchAdditionalInfoDisplay={launchAdditionalInfoDisplay}
    />
  ));
};

export const getColumnGroups = ({ answerComponents = [], questionsPerColumn }) => {
  if (!answerComponents.length) return null;

  if (questionsPerColumn !== DEFAULT_QUESTIONS_PER_COLUMN)
    return chunk(answerComponents, questionsPerColumn);

  if (answerComponents.length === 5) return chunk(answerComponents, 3);

  if (answerComponents.length > DEFAULT_QUESTIONS_PER_COLUMN * 2)
    return chunk(answerComponents, Math.ceil(answerComponents.length / 2)); // limit answers to 2 columns max

  return chunk(answerComponents, DEFAULT_QUESTIONS_PER_COLUMN);
};

export const getGridColumnStyles = (isMultiColumn, isRowLayout) => {
  const lgOffsetForColumnMapping = isMultiColumn ? 0 : 3; // for legacy column mapping inside grid
  const lgOffset = !isRowLayout ? lgOffsetForColumnMapping : 0;
  const mdOffset = !isRowLayout && isMultiColumn ? 0 : 2;
  const sm = 4;
  const md = 4;
  const lg = 6;

  return { mdOffset, lgOffset, sm, md, lg };
};
